import React from "react";
import { WHEN_COLORS, WHEN_LABEL, whenAriaLabel } from "./orderWhen";

/* Today (green) / Schedule (orange) on an order row (owner 10-24; orderWhen.js). The label text always says the mode
   (never colour only); a tap switches it. readOnly: the mode an order was placed with (a chip, not a button). */
const base = {
  display: "inline-flex", alignItems: "center", gap: 3, borderRadius: 999, padding: "2px 8px", fontSize: 10.5,
  fontWeight: 700, lineHeight: "16px", whiteSpace: "nowrap", borderWidth: 1, borderStyle: "solid",
};

const WhenToggle = ({ name, when, onToggle, disabled = false, readOnly = false }) => {
  const w = when === "schedule" ? "schedule" : "today";
  const c = WHEN_COLORS[w];
  const style = { ...base, background: c.bg, borderColor: c.border, color: c.fg };
  const icon = w === "schedule" ? "◷" : "●";
  if (readOnly) {
    return (
      <span style={style} data-when={w} data-testid="when-chip" aria-label={`${name}: ${WHEN_LABEL[w]}`}>
        <span aria-hidden="true">{icon}</span>
        {WHEN_LABEL[w]}
      </span>
    );
  }
  return (
    <button
      type="button"
      style={{ ...style, cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1 }}
      data-when={w}
      data-testid="when-toggle"
      disabled={disabled}
      onClick={() => { if (!disabled && onToggle) onToggle(); }}
      aria-label={whenAriaLabel(name, w)}
      title={`${WHEN_LABEL[w]} · tap for ${w === "schedule" ? WHEN_LABEL.today : WHEN_LABEL.schedule}`}
    >
      <span aria-hidden="true">{icon}</span>
      {WHEN_LABEL[w]}
    </button>
  );
};

export default WhenToggle;
